import { render, staticRenderFns } from "./SelectableCard.vue?vue&type=template&id=b2233716&scoped=true&"
import script from "./SelectableCard.vue?vue&type=script&lang=js&"
export * from "./SelectableCard.vue?vue&type=script&lang=js&"
import style0 from "./SelectableCard.vue?vue&type=style&index=0&id=b2233716&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2233716",
  null
  
)

export default component.exports